import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { VNDialog } from '../../VNCustomerFacingDisplay/components/VNDialog'
import { getConfirmPaymentReadyDialogOpen, getCustomerEnteringTipDialogOpen } from '../Selectors'
import { centsToDollars } from '../../utils/formatters'
import { setConfirmPaymentDialog, setOpenCustomerEnteringTipDialog } from '../ActionCreators'
import { sendCFDScreenNav } from '../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { CFD_POS_PAYMENT_FLOWS } from '../../VNCustomerFacingDisplay/Enums'
import { clearOrderInProgress } from '../../actions/order'
import useRemoteOrderTotal from '../../hooks/useRemoteOrderTotal'
import { clearRemoteOrderTotal } from '../../actions/orderTotalRemote'
import { getOrderInProgress } from '../../selectors/order'
import { isTabbed } from '../../utils/orderStates'
import { setCurrentPaymentFlow } from '../../VNCustomerFacingDisplay/ActionCreators'
import { getRoundUpForCharityFeatureEnabled } from '../../selectors/menus'
import { CFD_SCREEN } from '../../VNCustomerFacingDisplay/Reducer'

export const VNCustomerEnteringTipDialog = () => {
  const dispatch = useDispatch()

  const dialogOptions = useSelector((state) => getCustomerEnteringTipDialogOpen(state))
  const isOpen = dialogOptions?.get('open') || false
  const [, , resetOrderTotals] = useRemoteOrderTotal()

  const orderInProgress = useSelector((state) => getOrderInProgress(state))
  const roundUpEnabled = useSelector((state) => getRoundUpForCharityFeatureEnabled(state, dialogOptions?.get('amount')))
  const isConfirmPaymentOpen = useSelector(getConfirmPaymentReadyDialogOpen)

  const getSubtitle = () => {
    if (!dialogOptions?.get('tipsEnabled') && roundUpEnabled) {
      return 'Customer Entering Donation on {{AMOUNT}}'
    }

    if (roundUpEnabled) {
      return 'Customer Entering Tip & Donation on {{AMOUNT}}'
    }

    if (dialogOptions?.get('tipsEnabled')) {
      return 'Customer Entering Tip on {{AMOUNT}}'
    }

    return 'Customer Confirming Total'
  }
  useEffect(() => {
    if (!isOpen) return
    // issue with double dialogs
    if (isConfirmPaymentOpen) {
      dispatch(setConfirmPaymentDialog(false))
    }
  }, [dialogOptions, dispatch, isConfirmPaymentOpen, isOpen])

  if (!isOpen) return null

  return (
    <VNDialog
      open={isOpen}
      subTitle={getSubtitle().replace('{{AMOUNT}}', centsToDollars(dialogOptions?.get('amount')))}
      primaryButtonText={'GO BACK'}
      onPrimaryButtonClick={() => {
        // send cfd back to cart screen
        sendCFDScreenNav(CFD_SCREEN.CART)

        if (!isTabbed(orderInProgress)) {
          // reset order totals
          resetOrderTotals()

          clearRemoteOrderTotal()

          dispatch(clearOrderInProgress())
        }

        dispatch(setOpenCustomerEnteringTipDialog({ open: false }))

        dispatch(setCurrentPaymentFlow(CFD_POS_PAYMENT_FLOWS.UNSET, true))
      }}
    />
  )
}
